import React from 'react';
import Icon from '../../../components/AppIcon';

export default function WorkspaceStats({ stats }) {
  // Use stats from props, defaulting to zero values
  const displayStats = stats || {
    totalProjects: 0,
    published: 0,
    drafts: 0,
    deployments: 0
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="font-heading font-semibold text-lg text-foreground mb-4">
        Workspace Overview
      </h3>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-primary/10 text-primary rounded-lg flex items-center justify-center">
              <Icon name="Folder" size={16} />
            </div>
            <span className="text-sm text-muted-foreground">Total Projects</span>
          </div>
          <span className="font-semibold text-foreground">{displayStats?.totalProjects}</span>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-green-100 text-green-600 rounded-lg flex items-center justify-center">
              <Icon name="CheckCircle2" size={16} />
            </div>
            <span className="text-sm text-muted-foreground">Published</span>
          </div>
          <span className="font-semibold text-foreground">{displayStats?.published}</span>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-yellow-100 text-yellow-600 rounded-lg flex items-center justify-center">
              <Icon name="Edit3" size={16} />
            </div>
            <span className="text-sm text-muted-foreground">Drafts</span>
          </div>
          <span className="font-semibold text-foreground">{displayStats?.drafts}</span>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-blue-100 text-blue-600 rounded-lg flex items-center justify-center">
              <Icon name="Upload" size={16} />
            </div>
            <span className="text-sm text-muted-foreground">Deployments</span>
          </div>
          <span className="font-semibold text-foreground">{displayStats?.deployments}</span>
        </div>
      </div>
    </div>
  );
}